import { loggedIn } from 'Helpers/session';

export default () => (loggedIn() ? {
  handler: 'showRightSidebarComponent',
  data: () => 'cashout',
} : {
  handler: 'relativeUrl',
  data: () => '/login',
});
